import { Pipe, PipeTransform } from '@angular/core';
import { uniqBy } from 'lodash';

@Pipe({
  name: 'uniqBy'
})
export class UniqByPipe implements PipeTransform {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  transform(value: any[], propertyKey: string): any[] {
    return uniqBy(value, propertyKey);
  }
}
